export default "__VITE_ASSET__DquohZpM__"